import type { HttpGet } from '@/shared/infra/http'
import type { ListAnnouncements } from '@/modules/connect/use-cases'
import { mapConnectError } from './map-connect-error'
import { type AnnouncementDto, toAnnouncement } from './announcement-dto'

type ListAnnouncementsResponseDto = {
  items?: AnnouncementDto[]
  nextCursor?: string | null
}

export class EdgeListAnnouncementsRepository {
  constructor(private readonly http: HttpGet) {}

  execute: ListAnnouncements = async (params) => {
    const search = new URLSearchParams({
      orgId: params.orgId,
      orgType: params.orgType,
    })
    if (params.limit !== undefined) search.set('limit', String(params.limit))
    if (params.cursor) search.set('cursor', params.cursor)
    try {
      const data = await this.http.get<ListAnnouncementsResponseDto>({
        url: `/connect/announcements?${search.toString()}`,
      })
      return {
        items: (data?.items ?? []).map(toAnnouncement),
        nextCursor: data?.nextCursor ?? undefined,
      }
    } catch (err) {
      throw mapConnectError(err)
    }
  }
}
